import { render } from "./Aboutsy.vue?vue&type=template&id=acf9e0f0&scoped=true"
import script from "./Aboutsy.vue?vue&type=script&lang=js"
export * from "./Aboutsy.vue?vue&type=script&lang=js"

import "./Aboutsy.vue?vue&type=style&index=0&id=acf9e0f0&lang=scss&scoped=true"

import exportComponent from "D:\\code\\h5\\officialWeb-vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-acf9e0f0"]])

export default __exports__